<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="100"
    :disabled="disabled"
    transition="scale-transition"
    min-width="290px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <validation-provider v-slot="{ errors }" :rules="`${rules}|min:${min}`" :immediate="immediateValidate">
        <v-text-field
          v-model="dateFormatted"
          v-mask="mask"
          :prepend-icon="showIcon ? 'mdi-calendar' : ''"
          v-bind="attrs"
          :outlined="outlined"
          :label="label"
          :clearable="clearable"
          :hint="hint"
          :persistent-hint="persistentHint"
          :error-messages="errors"
          :disabled="disabled"
          v-on="on"
          @blur="formatValueTextField()"
          @click:clear="clear()"
          @keydown="preventBackspace($event)"
          @change="$emit('change')"
        />
      </validation-provider>
    </template>
    <v-date-picker
      v-model="date"
      :type="type"
      :disabled="disabled"
      locale="pt-br"
      @input="((menu = false), formatValuePicker())"
      @change="$emit('change')"
    />
  </v-menu>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    mixins: [dateFormatterMixins],

    props: {
      /* valor aceito: ####-##-## (Independente de ser do tipo month, deve receber uma data com tamanho 10) */
      value: {
        type: String,
        required: true
      },
      /* valores aceitos: (month || date) */
      type: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      showIcon: {
        type: Boolean,
        default: true
      },
      rules: {
        type: String,
        required: false,
        default: ''
      },
      outlined: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      immediateValidate: {
        type: Boolean,
        default: false
      },
      hint: {
        type: String,
        default: ''
      },
      persistentHint: {
        type: Boolean,
        default: false
      }
    },

    emits: ['change', 'input'],

    data: () => ({
      menu: false,
      date: null,
      dateFormatted: null
    }),

    computed: {
      min() {
        return this.type.toLowerCase() == 'month' ? '7' : '10';
      },
      mask() {
        return this.type.toLowerCase() == 'month' ? '##/####' : '##/##/####';
      }
    },

    mounted() {
      if (this.value) {
        const type = this.type.toLowerCase();
        this.date = type === 'month' ? this.formatMonthToPicker(this.value) : this.formatDateToPicker(this.value);
        this.dateFormatted = type === 'month' ? this.formatMonth(this.value) : this.formatDate(this.value);
      }
    },

    methods: {
      formatValueTextField() {
        const type = this.type.toLowerCase();
        this.date = type === 'month' ? this.parseMonth(this.dateFormatted) : this.parseDate(this.dateFormatted);

        this.emitEventVmodel();
      },

      formatValuePicker() {
        const type = this.type.toLowerCase();
        this.dateFormatted = type === 'month' ? this.formatMonth(this.date) : this.formatDate(this.date);

        this.emitEventVmodel();
      },

      emitEventVmodel() {
        if (this.date && this.date.length == this.min) {
          const finalValue = this.type === 'month' ? `${this.date}-01` : this.date;
          this.$emit('input', finalValue);
        }
      },

      clear() {
        this.menu = false;
        this.date = null;
        this.dateFormatted = null;
        this.$emit('input', null);
      },

      preventBackspace(e) {
        if (e.key === 'Backspace' || e.key === 'Delete') return this.clear();
      }
    },

    watch: {
      value(newValue) {
        const type = this.type.toLowerCase();
        this.date = type === 'month' ? this.formatMonthToPicker(newValue) : this.formatDateToPicker(newValue);
        this.dateFormatted = type === 'month' ? this.formatMonth(newValue) : this.formatDate(newValue);
      }
    }
  };
</script>
